import { Input } from "antd";

import { RVFormFloatingLabelWrap, RVFormItem } from "@regal-voice/ui";

import { UpdateContactFormPanelEvents } from "./Components/UpdateContactFormPanelEvents/UpdateContactFormPanelEvents";
import { UpdateContactFormPanelProfile } from "./Components/UpdateContactFormPanelProfile/UpdateContactFormPanelProfile";
import { UpdateContactForm } from "./constants";

import styles from "./UpdateContactFormItems.module.scss";

const FORM_DESCRIPTION = "Update a contact by updating their contact attributes and/or triggering an event.";

export function UpdateContactFormItems(): JSX.Element {
    return (
        <div className={styles.container}>
            <RVFormFloatingLabelWrap name={UpdateContactForm.updateContactName} label="Name of Update" showFormLabel>
                <Input />
            </RVFormFloatingLabelWrap>
            <div>
                <RVFormItem label="Update Contact Criteria" required description={FORM_DESCRIPTION} />
            </div>
            <UpdateContactFormPanelEvents />
            <div className={styles.profileContainer}>
                <UpdateContactFormPanelProfile />
            </div>
            <RVFormItem className={styles.listError} name={UpdateContactForm.updateContactError}></RVFormItem>
        </div>
    );
}
